<template>

  <v-toolbar app clipped-left class="primary" >
      <img src="../../../static/images/smartkidsmarket-logo.svg" style="height:60px; cursor:pointer" @click="gotoItems"/>
      <v-toolbar-title @click="gotoItems" style="cursor: pointer" >{{ artistName }}'s Store</v-toolbar-title>
      <v-spacer></v-spacer>
      <CartIcon v-on:gotoCart="$router.push({name: 'ViewCart'})"></CartIcon>
  </v-toolbar>

</template>

<script>
import {mapState} from 'vuex'
import CartIcon from './CartIcon.vue'
export default {
  name: 'TopBar',
  components: {
    CartIcon
  },
  computed: {
    ...mapState({
      artistName: state => state.shopping.name,
      showMenu: state => state.displaySettings.showMenu,
      navBarMenu: state => state.displaySettings.showNavbar
    })
  },
  data () {
    return {
    }
  },
  methods: {
    toggleMenu: function () {
      // Toggle the NavBar
      this.$store.commit('displaySettings/setShowNavbar', !this.navBarMenu)
    },
    gotoItems: function () {
      this.$router.push({name: 'ViewItems'})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
